import { useRovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const useAiFirstCreateEnabled = (): boolean => {
	const { data: rovoEntitlementData } = useRovoEntitlementResource();
	const res =
		rovoEntitlementData?.isRovoLLMEnabled === true &&
		rovoEntitlementData?.isBetaAiFeaturesEnabled === true &&
		fg('jira_aifc_enabled');
	return res;
};
